// extracted by mini-css-extract-plugin
module.exports = {"Box":"Slider-module--Box--U03tP","Slider":"Slider-module--Slider--ja4jD","FlexStart":"Slider-module--FlexStart--2SJZx"};